module.exports = __webpack_public_path__ + "img/3.b9433fe8.png";